export interface OpinionOption {
  id: number;
  label: string;
  icon: string;
  count: number;
  pct: number;
}

export const votePoll = {
  question: "看完目前的风评汇总，你对哇偶姐姐的真实看法更接近哪一种？",
  note: "本投票仅代表围观站网友的即时感受，非权威结论，随手投一票参与吃瓜。",
  options: [
    { id: 1, label: "真性情，被网暴有点冤", icon: "ri-emotion-happy-line", count: 1286, pct: 32 },
    { id: 2, label: "路人，纯来看个热闹", icon: "ri-user-smile-line", count: 1504, pct: 38 },
    { id: 3, label: "营业人设，观感不佳", icon: "ri-emotion-unhappy-line", count: 756, pct: 19 },
    { id: 4, label: "已取关，不再关注", icon: "ri-forbid-line", count: 434, pct: 11 },
  ],
};

export interface KeywordStat {
  word: string;
  count: number;
}

export const overviewStats = {
  positive: 24,
  neutral: 41,
  negative: 35,
  totalSamples: "12.6万",
  hotNote: "近期讨论样本中，中性围观占比最高，正面与负面声音并存，尚未形成一边倒定论。",
};

export const topKeywords: KeywordStat[] = [
  { word: "人设", count: 128 },
  { word: "真性情", count: 96 },
  { word: "直播回应", count: 87 },
  { word: "带货翻车", count: 72 },
  { word: "黑粉", count: 65 },
  { word: "路人缘", count: 58 },
  { word: "旧帖", count: 51 },
  { word: "情绪价值", count: 44 },
  { word: "理性吃瓜", count: 39 },
  { word: "站队", count: 33 },
];